var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#00a85a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H72V72H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M41.8,22.724H61a6,6,0,0,1,6,6v6.312a6,6,0,0,1-.45,2.286L57.265,59.867a3,3,0,0,1-2.775,1.857H4a3,3,0,0,1-3-3v-30a3,3,0,0,1,3-3H14.446A3,3,0,0,0,16.9,24.455L33.256,1.274A1.5,1.5,0,0,1,35.152.8l5.442,2.721a7.5,7.5,0,0,1,3.915,8.559ZM19,30.488V55.724H52.48L61,35.036V28.724H41.8a6,6,0,0,1-5.814-7.479L38.695,10.6a1.5,1.5,0,0,0-.783-1.713L35.929,7.9,21.8,27.914A9.049,9.049,0,0,1,19,30.488Zm-6,1.236H7v24h6Z",
    transform: "translate(2 1.276)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon-like.29a14a6a3c53f475d4d68d8f4e26d797.svg";
export { ForwardRef as ReactComponent };